import * as yup from 'yup';

const reviewSchema = yup.object({
  rating: yup
    .number()
    .min(1, 'A classificação é obrigatória')
    .max(5, 'Máximo de 5 estrelas')
    .required('A classificação é obrigatória'),
  comment: yup
    .string()
    .max(600, 'Máximo de 600 caracteres')
    .required('O texto da avaliação é obrigatório'),
  author: yup
    .string()
    .max(40, 'Máximo de 40 caracteres')
    .required('O nome do cliente é obrigatório'),
});

const instructorSchema = yup.object({
  name: yup.string().when('$isProgram', {
    is: true,
    then: schema => schema.required('O nome completo é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
  cref: yup.string().when('$isProgram', {
    is: true,
    then: schema => schema.required('O registro profissional é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
  biography: yup.string().when('$isProgram', {
    is: true,
    then: schema => schema.required('A biografia do instrutor é obrigatória'),
    otherwise: schema => schema.optional(),
  }),
  image: yup
    .object({
      preview: yup.string().optional(),
      file: yup.mixed().optional(),
    })
    .optional(),
});

export const contentSchema = yup.object({
  title: yup.string().optional(),
  durationTime: yup.string().when('$isProgram', {
    is: true,
    then: schema => schema.required('A duração é obrigatória'),
    otherwise: schema => schema.optional(),
  }),
  level: yup.string().when('$isProgram', {
    is: true,
    then: schema => schema.required('O nível é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
  objective: yup.string().when('$isProgram', {
    is: true,
    then: schema => schema.required('O objetivo é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
  mediaType: yup
    .string()
    .oneOf(['video', 'image'])
    .required('Selecione o tipo de mídia'),
  teaser: yup.string().when('mediaType', {
    is: 'video',
    then: schema => schema.required('O ID do vídeo é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
  mainImage: yup
    .object({
      preview: yup.string().optional(),
      file: yup.mixed().optional(),
    })
    .optional(),
  mainTitle: yup
    .string()
    .max(140, 'Máximo de 140 caracteres')
    .required('O título principal é obrigatório'),
  description: yup
    .string()
    .trim()
    .max(500, 'Máximo de 500 caracteres')
    .required('A descrição da landing page é obrigatória'),
  benefits: yup
    .array()
    .of(
      yup
        .string()
        .max(130, 'Máximo de 130 caracteres')
        .required('O benefício não pode ser vazio')
    )
    .min(3, 'Insira pelo menos 3 benefícios')
    .required('Insira pelo menos 3 benefícios'),
  reviews: yup
    .array()
    .of(reviewSchema)
    .min(3, 'Insira pelo menos 3 depoimentos')
    .required('Insira pelo menos 3 depoimentos'),
  reviewsSectionTitle: yup
    .string()
    .required('O título da seção de depoimentos é obrigatório'),
  instructor: instructorSchema.optional(),
  programLength: yup.string().when('$isCombo', {
    is: true,
    then: schema => schema.required('A quantidade de programas é obrigatória'),
    otherwise: schema => schema.optional(),
  }),
  programImages: yup.array().when('$isCombo', {
    is: true,
    then: schema =>
      schema
        .min(3, 'Insira pelo menos 3 imagens no carrossel')
        .required('Insira pelo menos 3 imagens no carrossel'),
    otherwise: schema => schema.optional(),
  }),
  buttonText: yup.string().when('$isCombo', {
    is: true,
    then: schema => schema.required('O texto do botão CTA é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
});

export type ContentFormData = yup.InferType<typeof contentSchema>;

export const contentDefaultValues: ContentFormData = {
  title: '',
  durationTime: '',
  level: '',
  objective: '',
  mediaType: 'video',
  teaser: '',
  mainImage: { preview: '', file: undefined },
  mainTitle: '',
  description: '',
  benefits: [],
  reviews: [],
  reviewsSectionTitle: '',
  instructor: {
    name: '',
    cref: '',
    biography: '',
    image: { preview: '', file: undefined },
  },
  programLength: '',
  programImages: [],
  buttonText: '',
};
